import Immutable from 'seamless-immutable'
import {
  ACCOUNT_FORGOT_PASSWORD_ATTEMPT,
  ACCOUNT_FORGOT_PASSWORD_FAILURE,
  ACCOUNT_FORGOT_PASSWORD_SUCCESS,
  COGNITO_LOGIN_ATTEMPT,
  COGNITO_LOGIN_USER,
  SET_USER,
  ACCOUNT_LOGIN_RESET,
  ACCOUNT_LOGIN_SUCCESS,
  ACCOUNT_LOGIN_FAILURE,
  UPDATE_COMPANY_SUCCESS,
  ACCOUNT_SET_PREFERENCES,
  ACCOUNT_GET_PREFERENCES,
  ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES,
  ACCOUNT_SET_PREFERENCES_SHOW_LOADING,
  ACCOUNT_SET_PREFERENCES_HIDE_LOADING
} from './actionTypes'

const initialState = Immutable({
  authenticated: false,
  loginStatus: 'idle',
  countries: [],
  permissions: []
})

export default function State(store = initialState, action) {
  let permissions

  switch (action.type) {
    case ACCOUNT_LOGIN_RESET:
      store = initialState
      break

    case ACCOUNT_FORGOT_PASSWORD_ATTEMPT:
      store = { ...store, forgotPasswordStatus: 'attempting' }
      break

    case ACCOUNT_FORGOT_PASSWORD_SUCCESS:
      store = { ...store, forgotPasswordStatus: 'success' }
      break

    case ACCOUNT_FORGOT_PASSWORD_FAILURE:
      store = { ...store, forgotPasswordStatus: 'failure' }
      break

    case COGNITO_LOGIN_ATTEMPT:
      store = { ...store, loginError: '' }
      store = { ...store, loginStatus: action.payload.status }
      break

    case COGNITO_LOGIN_USER:
      store = { ...store, authenticated: true }
      store = { ...store, loginStatus: 'success' }
      break

    case SET_USER:
      store = { ...store, user: action.payload }
      permissions = []
      store = { ...store, permissions }
      if (store.user.isAdmin) {
        store = { ...store, permissions: ['authenticated', 'administrator', 'addMinimumWage', 'addCompliance', 'editMinimumWage', 'editCompliance', 'deleteMinimumWage', 'deleteCompliance'] }
      } else {
        store = { ...store, permissions: ['authenticated'] }
      }
      break

    case ACCOUNT_LOGIN_SUCCESS:
      store = { ...store, company: action.payload.company }
      store = { ...store, token: action.payload.token }
      store = { ...store, user: action.payload.user }
      store = { ...store, authenticated: true }
      store = { ...store, loginStatus: 'success' }
      permissions = Immutable.asMutable(store.permissions).filter((item) => !item.includes('has'))
      if (!permissions.includes('authenticated')) permissions.push('authenticated')

      if (store.user && store.user.products) {
        if (store.company.minimumWage.hasDashboardAccess && store.user.products.includes('MINIMUM_WAGE')) { permissions.push('hasMinimumWage') }
        if (store.company.paidLeave.hasDashboardAccess && store.user.products.includes('PAID_LEAVE')) { permissions.push('hasPaidLeave') }
        if (store.company.postings.hasDashboardAccess && store.user.products.includes('POSTINGS')) { permissions.push('hasCompliance') }
      }

      store = { ...store, permissions }
      store = { ...store, countries: ['US'] }
      break

    case ACCOUNT_LOGIN_FAILURE:
      store = { ...store, authenticated: false }
      store = { ...store, loginStatus: 'failure' }

      const errorCodeMessages = {
        ECONNABORTED: {
          keyStore: 'loginError',
          message: 'Log in has timed out. Please try again, and if the problem persists please contact your Account Manager.'
        },
        ETIMEDOUT: {
          keyStore: 'loginError',
          message: 'Log in has timed out. Please try again, and if the problem persists please contact your Account Manager.'
        },
        ERR_WS_INVALID_EMAIL: {
          keyStore: 'loginError',
          message: 'The email address is invalid. Please correct it.'
        },
        ERR_WS_CUSTOMER_LOGIN: {
          keyStore: 'loginError',
          message: 'The email or password you entered is incorrect, please correct your email or password. If you have any questions or need to register please contact your account manager or customer service.'
        },
        UserNotFoundException: {
          keyStore: 'loginError',
          message: 'The email or password you entered is incorrect, please correct your email or password. If you have any questions or need to register please contact your account manager or customer service.'
        },
        NotAuthorizedException: {
          keyStore: 'loginError',
          message: 'The email or password you entered is incorrect, please correct your email or password. If you have any questions or need to register please contact your account manager or customer service.'
        }
      }

      if (errorCodeMessages[action.payload.error.errorCode]) {
        store = { ...store, loginError: errorCodeMessages[action.payload.error.errorCode].message }
      } else {
        store = { ...store, loginError: 'There was an error logging in. Please try again, if the problem persists please contact your Account Manager.' }
      }
      break

    case UPDATE_COMPANY_SUCCESS:
      store = { ...store, company: { ...store.company, ...action.payload } }
      sessionStorage.setItem('company', JSON.stringify(store.company))
      break

    case ACCOUNT_SET_PREFERENCES:
      store = { ...store, user: { ...store.user, user_preferences: action.payload } }
      break

    case ACCOUNT_SET_USER_NOTIFICATION_PREFERENCES:
      store = { ...store, user: { ...store.user, companies: action.payload } }
      break

    case ACCOUNT_GET_PREFERENCES:
      store = { ...store, user: action.payload }
      break

    case ACCOUNT_SET_PREFERENCES_SHOW_LOADING:
      store = { ...store, userPreferencesLoading: true }
      break

    case ACCOUNT_SET_PREFERENCES_HIDE_LOADING:
      store = { ...store, userPreferencesLoading: false }
      break

    default:
      break
  }

  return store
}
